export function initHomeHeroSlider() {
	const el = document.querySelector( '.splide-img-slider' );
	if ( ! el ) return;

	const slider = new Splide( el, {
		type        : 'fade',
		rewind      : true,
		speed       : 1600,
		easing      : 'cubic-bezier(0.4, 0, 0.2, 1)',
		autoplay    : true,
		interval    : 5000,
		pauseOnHover: false,
		arrows      : false,
		pagination  : true,
	} );

	slider.mount();
}
